import { EndPoint } from 'data/endPoints';
import { InOut } from 'types/feature/parking.type';
import useParkingAxios from 'utils/axios/parkingAxios';
import { getOneYearAgoTimestamp } from 'utils/dateTime/timeStamp';

export default function useParking() {
  const { api } = useParkingAxios();

  const getInOutList = async (plateNumber: string) => {
    const timestamps = getOneYearAgoTimestamp();
    const list = await api.get<InOut[]>(EndPoint.parking, {
      params: {
        plateNumber,
        fromAt: timestamps.oneYearAgo,
        toAt: timestamps.current,
        page: 1,
        size: 50,
      },
    });
    return list;
  };

  return { getInOutList };
}
